import { shareListModalStyles } from "@insite/content-library/Components/ShareListModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

shareListModalStyles.sendButton = {
    mergeCss: true,
    variant: "primary",
    css: css`
        width: 100%;
    `,
};

shareListModalStyles.cancelButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};

shareListModalStyles.shareListTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
            div[data-test-selector^="tooltip_TooltipInfo"] {
                position: relative !important;
            }
        `,
        tooltipContainer: css`
            margin-left: -110px;
            position: absolute;
            left: 100%;
            margin-bottom: 22px;
           
        `,
        tooltipBody: css`
            padding: 5px;
        `,
        tooltipArrow: css`
            left: 94%;
        `,
    },
    typographyProps: {
        lineHeight: "16px",
    },
};
